var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TableText',{attrs:{"prop":"display_name","label":"名称","width":120}}),_c('TableOptions',{attrs:{"prop":"racing_track","label":"赛道","width":120}}),_c('TableText',{attrs:{"prop":"promoted_number","label":"晋级数","width":120}}),_c('TableOptions',{attrs:{"prop":"start_rule","label":"发车规则","width":120}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }